import { render, staticRenderFns } from "./EducationPage.vue?vue&type=template&id=1218fcf4&"
import script from "./EducationPage.vue?vue&type=script&lang=js&"
export * from "./EducationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports